import { subscribe, broadcast } from '@gem/modules/eventBus';

function getBusStation() {
  return 'select-mention';
}

export const subscribeSelectMention = (callback) => {
  return subscribe(getBusStation(), callback);
};

export const broadcastSelectMention = (mention) => {
  broadcast(getBusStation(), mention);
};
